import { ref } from 'vue';
import { api } from '@/services/api';
import { useAsync } from '@/composables/useAsync';
import type { Mission } from '@/types/mission';

export function useMission() {
  const mission = ref<Mission | null>(null);
  const { isLoading: loading, error, run } = useAsync();

  async function getById(id: number | string) {
    const data = await run(
      () => api.get<Mission>(`/cms/missions/${id}`, { params: { 'File.category': 'MISSION_DOCUMENT' } }).then((r) => r.data),
      'Impossible de charger la mission',
    );
    if (data) mission.value = data;
    return data;
  }

  return { mission, loading, error, getById };
}
